import { EUserType } from "../../interfaces";

const TOKEN_KEY = "jwt-token";

export interface IUserInfo {
  firstName: string | undefined;
  lastName: string | undefined;
  patronymic: string | undefined;
  phone: string;
  type: EUserType;
  id: number;
  email: string | undefined;
}

export async function setTokens({ accessToken }: { accessToken: string }) {
  await localStorage.setItem(TOKEN_KEY, accessToken);
}

export async function removeAuthData() {
  await localStorage.removeItem(TOKEN_KEY);
}

export function getAccessToken() {
  return localStorage.getItem(TOKEN_KEY);
}

const localStorageServices = {
  setTokens,
  getAccessToken,
  removeAuthData,
};

export default localStorageServices;
